"use client";
import { StickyScroll } from "../components/ui/stickyScrollReveal";

const content = [
  {
    title: "Define Product, Packaging, and Priorities",
    description:
      "First, we specify the product and packaging type to optimize. We collaborate with the client to assess and prioritize aspects like environmental impact, consumer acceptance, and cost through structured questions and interviews.",
    content: (
      <img
        src="/planning.jpeg"
        width={300}
        height={300}
        className="h-full w-full object-cover"
        alt="Define Product and Packaging"
      />
    ),
  },
  {
    title: "Establish Parameter Space and Determine Sources of Uncertainties",
    description:
      "We define the parameter space and gather data on various packaging options using both external and internal tools. This step includes accounting for data uncertainty.",
    content: (
      <img
        src="/parameter.jpeg"
        width={300}
        height={300}
        className="h-full w-full object-cover"
        alt="Parameter Space"
      />
    ),
  },
  {
    title: "Objectives and AI-based Optimization",
    description: "Next, we set objectives and perform AI-based optimization.",
    content: (
      <div className="w-[300px] h-[350px] p-0 m-0">
        <img
          src="/ai.jpeg"
          className="w-full h-full object-cover"
          alt="AI-based Optimization"
        />
      </div>
    ),
  },
  {
    title: "Packaging Options",
    description:
      "Finally, we propose various packaging or design options based on the prioritized aspects.Different designs may result based on the importance of each evaluated aspect, e.g. environmental impact or consumer acceptance.",
    content: (
      <img
        src="/package.jpeg"
        width={300}
        height={300}
        className="h-full w-full object-cover"
        alt="Running out of Content"
      />
    ),
  },
  {
    title: " ",
    description: " ",
    content: (
      <img
        src="https://via.placeholder.com/300x300?text=Placeholder"
        width={300}
        height={300}
        className="h-full w-full object-cover"
        alt="Placeholder"
      />
    ),
  },
];

export function StickyScrollReveal() {
  return (
    <div className=" p-10 px-0">
      <StickyScroll content={content} />
    </div>
  );
}
